export default __webpack_public_path__ + "65817209e9a2e07f6222ebb926581312.png";